module.exports = __webpack_public_path__ + "static/media/9734918-394x360.7ba229ec.jpg";